// Branded string helper — prevents passing raw strings in the wrong position
type Brand<K, T> = K & { readonly __brand: T };

export type AuthCode = Brand<string, "AuthCode">;
export type RefreshToken = Brand<string, "RefreshToken">;
export type CodeVerifier = Brand<string, "CodeVerifier">;
export type OAuthState = Brand<string, "OAuthState">;

export type AuthUser = {
  id: string;
  email?: string;
  name: string;
  firstName: string;
  lastName: string;
  username: string;
};

export type JwtPayload = {
  sub: string;
  exp: number;
  iat: number;
  iss: string;
  email?: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  email_verified?: boolean;
  hd?: string;
  realm_access?: { roles: string[] };
};

export type TokenResponse = {
  access_token: string;
  refresh_token?: string;
  id_token?: string;
  expires_in?: number;
  token_type?: string;
};

export type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export type AuthState =
  | { status: "loading" }
  | {
      status: "authenticated";
      user: AuthUser;
      token: string;
    }
  | { status: "unauthenticated" };

export class AuthError extends Error {
  constructor(
    message: string,
    readonly status: number | null,
    readonly cause?: unknown,
  ) {
    super(message);
    this.name = "AuthError";
  }
}
